<div class="progress-bar">
  <div
    *ngFor="let item of [].constructor(noOfView); let i = index"
    class="progress-bar-tab"
    [ngClass]="getProgressBarCssClass(i,noOfView,signUpPageCount)"
  ></div>
</div>
